export const hamburgers = [
    {
        id: 0,
        immagini: [
            '/assets/images/burger0-0.jpg',
            '/assets/images/burger0-1.jpg',
            '/assets/images/burger0-2.jpg',
            '/assets/images/burger0-3.jpg'
        ],
        corrente: 0
    },
    {
        id: 1,
        immagini: [
            '/assets/images/burger1-0.jpg',
            '/assets/images/burger1-1.jpg',
            '/assets/images/burger1-2.jpg',
            '/assets/images/burger1-3.jpg'
        ],
        corrente: 0
    },
    {
        id: 2,
        immagini: [
            '/assets/images/burger2-0.jpg',
            '/assets/images/burger2-1.jpg',
            '/assets/images/burger2-2.jpg',
            '/assets/images/burger2-3.jpg'
        ],
        corrente: 0
    },
    {
        id: 3,
        immagini: [
            '/assets/images/burger3-0.jpg',
            '/assets/images/burger3-1.jpg',
            '/assets/images/burger3-2.jpg',
            '/assets/images/burger3-3.jpg'
        ],
        corrente: 0
    },
    {
        id: 4,
        immagini: [
            '/assets/images/burger4-0.jpg',
            '/assets/images/burger4-1.jpg',
            '/assets/images/burger4-2.jpg',
            '/assets/images/burger4-3.jpg'
        ],
        corrente: 0
    },
    {
        id: 5,
        immagini: [
            '/assets/images/burger5-0.jpg',
            '/assets/images/burger5-1.jpg',
            '/assets/images/burger5-2.jpg',
            '/assets/images/burger5-3.jpg'
        ],
        corrente: 0
    },
    {
        id: 6,
        immagini: [
            '/assets/images/burger6-0.jpg',
            '/assets/images/burger6-1.jpg',
            '/assets/images/burger6-2.jpg',
            '/assets/images/burger6-3.jpg'
        ],
        corrente: 0
    },
    {
        id: 7,
        immagini: [
            '/assets/images/burger7-0.jpg',
            '/assets/images/burger7-1.jpg',
            '/assets/images/burger7-2.jpg',
            '/assets/images/burger7-3.jpg'
        ],
        corrente: 0
    },
    {
        id: 8,
        immagini: [
            '/assets/images/burger8-0.jpg',
            '/assets/images/burger8-1.jpg',
            '/assets/images/burger8-2.jpg',
            '/assets/images/burger8-3.jpg'
        ],
        corrente: 0
    },
    {
        id: 9,
        immagini: [
            '/assets/images/burger9-0.jpg',
            '/assets/images/burger9-1.jpg',
            '/assets/images/burger9-2.jpg',
            '/assets/images/burger9-3.jpg'
        ],
        corrente: 0
    },
    {
        id: 10,
        immagini: [
            '/assets/images/burger10-0.jpg',
            '/assets/images/burger10-1.jpg',
            '/assets/images/burger10-2.jpg',
            '/assets/images/burger10-3.jpg'
        ],
        corrente: 0
    },
    {
        id: 11,
        immagini: [
            '/assets/images/burger11-0.jpg',
            '/assets/images/burger11-1.jpg',
            '/assets/images/burger11-2.jpg',
            '/assets/images/burger11-3.jpg'
        ],
        corrente: 0
    },
    {
        id: 12,
        immagini: [
            '/assets/images/burger12-0.jpg',
            '/assets/images/burger12-1.jpg',
            '/assets/images/burger12-2.jpg',
            '/assets/images/burger12-3.jpg'
        ],
        corrente: 0
    },
    {
        id: 13,
        immagini: [
            '/assets/images/burger13-0.jpg',
            '/assets/images/burger13-1.jpg',
            '/assets/images/burger13-2.jpg',
            '/assets/images/burger13-3.jpg'
        ],
        corrente: 0
    },
    {
        id: 14,
        immagini: [
            '/assets/images/burger14-0.jpg',
            '/assets/images/burger14-1.jpg',
            '/assets/images/burger14-2.jpg',
            '/assets/images/burger14-3.jpg'
        ],
        corrente: 0
    }
];



/** WEBPACK FOOTER **
 ** ./components/hamburger-array.js
 **/